import { useHistory } from "react-router-dom";
import { SERVER_URL } from "../ServerUrl";
import {
  PAST_BOOKINGS_LOADED,
  UPCOMING_BOOKINGS_LOADED,
  ADD_BOOKING_FAIL,
  ADD_BOOKING_SUCCESS,
  ADD_SEAT_DETAILS, UPDATE_DEPARTURE_TRIPID, UPDATE_RETURN_TRIPID,
  UPDATE_DISCOUNT_PERCENTAGE,
  UPDATE_PASSENGER_DETAIL,
  UPDATE_DPARTURETRIPS_SEATS,
  UPDATE_DPARTURETRIP_DATE,
  UPDATE_RETURNTRIP_DATE,
  UPDATE_DPARTURETRIP_REGULARID,
  UPDATE_RETURNTRIP_REGULARID,
  UPDATE_OLD_BOOKING,
  UPDATE_CURRENT_TRIP,
  RESET_BOOKING_INFO,
  SET_COMPLETEDBOOKING,
  OPERATOR_PAST_BOOKINGS_LOADED,
  OPERATOR_UPCOMING_BOOKINGS_LOADED,
  UPDATE_PACKAGEID,
  SET_PACKACCOM,
  UPDATE_RETURNTRIPS_SEATS
} from "./types";
// Common
import { Alert } from "../admin/common/Alert";
// Axios
import axios from "axios";
// Redux
import setAuthToken from "../admin/utils/setAuthToken";

export const addBooking = (bookingObj) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  if (sessionStorage.token) {
    setAuthToken(sessionStorage.token);
  }

  const body = JSON.stringify(bookingObj);

  try {
    const res = await axios.post(
      `${SERVER_URL}/bookings/bookSeats`,
      body,
      config
    );

    dispatch({
      type: ADD_BOOKING_SUCCESS,
      payload: res.data,
    });

    Alert("success", "Booking added");
    /*    window.location.reload() */
  } catch (error) {
    dispatch({
      type: ADD_BOOKING_FAIL,
    });
  }
};

export const getBookings = () => async (dispatch) => {
  if (sessionStorage.token) {
    setAuthToken(sessionStorage.token);
  }

  try {
    const res = await axios.get(`${SERVER_URL}/bookings/myBookings`);
    console.log(res, "resallPakcgePlusBookings")
    dispatch({
      type: UPCOMING_BOOKINGS_LOADED,
      payload: res.data.upcomingBookings,
    });

    dispatch({
      type: PAST_BOOKINGS_LOADED,
      payload: res.data.pastBookings,
    });
  } catch (error) {
    Alert("error", "Bookings are not loaded");
  }
};

export const getOperatorBookings = () => async (dispatch) => {
  if (sessionStorage.token) {
    setAuthToken(sessionStorage.token);
  }

  try {
    const res = await axios.get(`${SERVER_URL}/bookings/myBookings`);

    dispatch({
      type: OPERATOR_UPCOMING_BOOKINGS_LOADED,
      payload: res.data.upcomingBookings,
    });

    dispatch({
      type: OPERATOR_PAST_BOOKINGS_LOADED,
      payload: res.data.pastBookings,
    });
  } catch (error) {
    Alert("error", "Bookings are not loaded");
  }
};


export const UpdateDepartTripId = (requestInfor) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_DEPARTURE_TRIPID,
      payload: requestInfor, // Add payload if necessary
    });
    dispatch({
      type: UPDATE_DPARTURETRIP_REGULARID,
      payload: requestInfor?._id,
    });
  };
};


export const SelectDepartTripId = ({ tripId, date }) => async (dispatch) => {
  const formattedDate = date?.replace(/\//g, '-');
  try {
    const res = await axios.post(
      `${SERVER_URL}/trip/add-extended`,
      { tripId, date: formattedDate }
    );

    dispatch({
      type: UPDATE_DEPARTURE_TRIPID,
      payload: res?.data?.trip,
    });
    dispatch({
      type: UPDATE_DPARTURETRIP_REGULARID,
      payload: tripId,
    });
  } catch (error) {
    // dispatch({
    //   // type: ADD_BOOKING_FAIL,
    // });
    console.log(error, "123error123")
  }
};

export const SelectReturnTripId = ({ tripId, date }) => async (dispatch) => {

  const formattedDate = date?.replace(/\//g, '-');
  try {
    const res = await axios.post(
      `${SERVER_URL}/trip/add-extended`,
      { tripId, date: formattedDate }
    );
    dispatch({
      type: UPDATE_RETURN_TRIPID,
      payload: res?.data?.trip,
    });
    dispatch({
      type: UPDATE_RETURNTRIP_REGULARID,
      payload: tripId,
    });
  } catch (error) {
    // dispatch({
    //   // type: ADD_BOOKING_FAIL,
    // });
    console.log(error, "123error123")
  }
};



export const UpdateReturnTripId = (requestInfor) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_RETURN_TRIPID,
      payload: requestInfor, // Add payload if necessary
    });
    dispatch({
      type: UPDATE_RETURNTRIP_REGULARID,
      payload: requestInfor?._id,
    });
  };
};

export const UpdateDiscountPercentage = (requestInfor) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_DISCOUNT_PERCENTAGE,
      payload: requestInfor, // Add payload if necessary
    });
  };
};
export const UpdatePassengerDetail = (passengerDetail) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_PASSENGER_DETAIL,
      payload: passengerDetail, // Add payload if necessary
    });
  };
};


export const UpdateDepartureSeats = (selectedSeats) => {
  console.log(selectedSeats, "selectedSeats")
  return (dispatch) => {
    dispatch({
      type: UPDATE_DPARTURETRIPS_SEATS,
      payload: selectedSeats, // Add payload if necessary
    });
  };
};

export const UpdateReturnSeats = (selectedSeats) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_RETURNTRIPS_SEATS,  // <-- you’ll need to define this in your constants
      payload: selectedSeats,
    });
  };
};

export const UpdateDepartureDate = (selectedSeats) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_DPARTURETRIP_DATE,
      payload: selectedSeats,
    });
  };
};

export const UpdateReturnDate = (selectedSeats) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_RETURNTRIP_DATE,
      payload: selectedSeats,
    });
  };
};
export const UpdateOldBooking = (selectedSeats) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_OLD_BOOKING,
      payload: selectedSeats,
    });
  };
};

export const UpdateCurrentTrip = (selectedSeats) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_CURRENT_TRIP,
      payload: selectedSeats,
    });
  };
};
export const ResetBookingInfo = () => {
  return (dispatch) => {
    dispatch({
      type: RESET_BOOKING_INFO,
    });
  };
};

export const SetCompletedBooking = (selectedSeats) => {
  return (dispatch) => {
    dispatch({
      type: SET_COMPLETEDBOOKING,
      payload: selectedSeats,
    });
  };
};


export const SelectPackageId = ({ packageId, date, packageAccom }) => async (dispatch) => {
  const formattedDate = date?.replace(/\//g, '-');
  try {
    const res = await axios.post(
      `${SERVER_URL}/package/add-extended`,
      { packageId, date: formattedDate }
    );

    console.log(res, "respackage")
    dispatch({
      type: UPDATE_PACKAGEID,
      payload: res?.data?.package,
    });
    dispatch({
      type: UPDATE_DPARTURETRIP_REGULARID,
      payload: packageId,
    });
    dispatch({
      type: SET_PACKACCOM,
      payload: packageAccom,
    });
  } catch (error) {
    // dispatch({
    //   // type: ADD_BOOKING_FAIL,
    // });
    console.log(error, "123error123")
  }
};


export const NonRegularPackageId = (requestInfor, packageAccom) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_PACKAGEID,
      payload: requestInfor, // Add payload if necessary
    });
    dispatch({
      type: UPDATE_DPARTURETRIP_REGULARID,
      payload: requestInfor?._id,
    });
    dispatch({
      type: SET_PACKACCOM,
      payload: packageAccom,
    });
  };
};